/* eslint-disable react/prop-types */
// PumpFrostWater.jsx
import React from 'react'

const PumpFrostWaterDefault = function PumpFrostWaterDefault ({ style }) {
  return (
    <PumpFrostWater style={style} />
  )
}

export default PumpFrostWaterDefault

const PumpFrostWater = function PumpFrostWater ({ style }) {
  const defaultStyle = {
    fill: '#284047',
    fillRule: 'nonzero',
    clipRule: 'evenodd',
  }

  const svgStyle = { ...defaultStyle, ...style, stroke: 'none' }

  return (
    <svg
      style={svgStyle}
      viewBox='0 0 75 75'
    >
      <description>frost water pump icon</description>
      <title>frost water pump</title>
      <g
        style={{
          transform: 'translate(11px, 9px) scale(1.5)',
        }}
      >
        <g id='frost-water-pump'>
          <path
            d='M31.2,17.8l-3.4,-1.3c-0.1,0 -0.2,-0.1
            -0.3,-0.1l-5.5,0l0,-1.5c0,-0.2 -0.1,-0.3 -0.2,-0.5l-1.4,-1.4c-0.1,-0.1 -0.3,-0.2
            -0.5,-0.2l-4.3,0c-0.4,0 -0.7,0.3 -0.7,0.7l0,3l-4.9,0l-0.5,0l-2,0c-1.5,0 -2.7,1.2
            -2.7,2.7l0,1.2l-0.7,0c-0.7,0 -1.2,0.5 -1.2,1.2l0,2.7l-2.2,0c-0.4,0 -0.7,0.3
            -0.7,0.7c0,0.4 0.3,0.7 0.7,0.7l2.2,0l0,2.7c0,0.7 0.5,1.2 1.2,1.2l0.7,0l0,1.2c0,1.5 1.2,2.7
            2.7,2.7c0.7,0 5.5,0 6.3,0l0,1.3l-3,0c-0.4,0
            -0.7,0.3 -0.7,0.7l0,2.6c0,0.4 0.3,0.7 0.7,0.7l14.2,0c0.4,0 0.7,-0.3 0.7,-0.7l0,-2.6c0,-0.4
            -0.3,-0.7 -0.7,-0.7l-3,0l0,-1.3l5.4,0c0.1,0 0.1,0 0.3,-0.1l3.4,-1.3c0.3,-0.1 0.4,-0.3 0.4,
            -0.6l0,-13.2c0.1,-0.2 -0.1,-0.5 -0.3,-0.5Zm-21.1,5.9l16.7,0l0,1.8l-16.7,0l0,-1.8Zm16.7,
            -1.3l-16.7,0l0,-1.8l16.7,0l0,1.8Zm-16.7,4.4l16.7,0l0,1.8l-16.7,0l0,-1.8Zm6.1,-12.7l3.4,
            0l1,1.1l0,1.3l-4.4,0l0,-2.4Zm10.6,3.6l0,1.6l-16.7,0l0,-1.6c5.9,0 10.5,0 16.7,0Zm-22.6,
            10.2l0,-6.4l0.5,0l0,6.4l-0.5,0Zm1.8,2.5c0,-5.9 0,-5.5 0,-11.3c0,-0.7 0.6,-1.4 1.4,-1.4l1.4,0l0,
            14.1l-1.4,0c-0.8,0 -1.4,-0.6 -1.4,-1.4Zm4.1,-0.6l16.7,0l0,1.9l-16.7,0l0,-1.9Zm14.2,
            7.3l-12.9,0l0,-1.3l12.9,0l0,1.3Zm-3.5,-2.7l-5.7,0l0,-1.3l5.7,0l0,1.3Zm9.4,-3.7l-2.1,0.8l0,
            -13.5l2.1,0.8l0,11.9Z'
          />
          <path
            d='M19.1,14.5l-1.4,0c-0.4,0 -0.7,0.3 -0.7,0.7c0,0.4 0.3,0.7
            0.7,0.7l1.4,0c0.4,0 0.7,-0.3 0.7,-0.7c0,-0.4 -0.3,-0.7 -0.7,-0.7Z'
          />
        </g>
        <path
          id='frost-water-pump-snowflake'
          d='M24.3,5.3l-1.5,-0.9l0.7,-1.2l1.5,0.9l0,-1.7l1.4,0l0,2.5l2.5,1.5l0,-3l-2.1,-1.2l0.7,-1.2l1.4,
          0.8l0,-1.8l1.4,0l0,1.8l1.5,-0.8l0.7,1.3l-2.1,1.2l0,3l2.6,-1.5l0,-2.5l1.4,0l0,1.7l1.5,-0.9l0.7,
          1.2l-1.5,0.9l1.4,0.9l-0.7,1.2l-2.1,-1.3l-2.7,1.4l2.6,1.5l2.1,-1.3l0.7,1.2l-1.4,1l1.5,0.9l-0.7,
          1.2l-1.5,-0.9l0,1.7l-1.4,0l0,-2.5l-2.6,-1.5l0,3l2.1,1.2l-0.7,1.3l-1.5,-0.8l0,1.8l-1.4,0l0,
          -1.8l-1.4,0.8l-0.7,-1.3l2.1,-1.2l0,-3l-2.5,1.5l0,2.5l-1.4,0l0,-1.7l-1.5,0.9l-0.7,-1.2l1.5,
          -0.9l-1.4,-0.9l0.7,-1.2l2.1,1.3l2.6,-1.5l-2.5,-1.5l-2.1,1.3l-0.7,-1.2l1.4,-1Z'
        />
      </g>
    </svg>
  )
}
